import * as actionTypes from '../actions/actionTypes'
import initialState from './initialState';

const tokenReducer = (state = initialState.token, action) => {
    switch (action.type) {
        case actionTypes.SET_TOKEN:
            return action.payload
        case actionTypes.REMOVE_TOKEN:
            return action.payload
        default:
            return state
    }
}

export default tokenReducer